import React from 'react';
import { motion } from 'framer-motion';
import { Play, Download, Clock, Music } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import musicArt from '../assets/aigc/images/music-library-art_1771110044_000.png';

const tracks = [
  { id: 1, title: "Deep Resonance", duration: "45:00", type: "Sound Journey", price: "€15" },
  { id: 2, title: "Morning Stillness", duration: "20:00", type: "Meditation", price: "€10" },
  { id: 3, title: "Ocean of Awareness", duration: "60:00", type: "Immersion", price: "€20" },
  { id: 4, title: "Rooting", duration: "30:00", type: "Grounding", price: "€12" },
  { id: 5, title: "Ether", duration: "40:00", type: "Expansion", price: "€15" },
  { id: 6, title: "Silence Between", duration: "15:00", type: "Rest", price: "€8" },
];

const MusicLibrary = () => {
  return (
    <div className="bg-background min-h-screen text-text font-sans selection:bg-primary selection:text-background">
      <Navbar />
      
      <div className="pt-32 pb-24 container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-primary text-xs font-sans uppercase tracking-[0.3em] block mb-4">Digital Collection</span>
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-6">Music Library</h1>
          <p className="text-text-muted max-w-2xl mx-auto font-light leading-relaxed">
            Original sound journeys and compositions available for download. Created for meditation, relaxation, emotional processing, and conscious listening.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tracks.map((track, index) => (
            <motion.div
              key={track.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group bg-surface rounded-sm overflow-hidden hover:bg-white/5 transition-colors duration-300"
            >
              <div className="relative aspect-square overflow-hidden">
                <img src={musicArt} alt={track.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors duration-500"></div>
                
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <button className="w-16 h-16 bg-primary/90 rounded-full flex items-center justify-center text-background hover:scale-110 transition-transform duration-300">
                    <Play className="ml-1 fill-current" size={24} />
                  </button>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <span className="text-primary text-[10px] uppercase tracking-widest block mb-1">{track.type}</span>
                    <h3 className="text-xl font-serif text-white group-hover:text-primary transition-colors">{track.title}</h3>
                  </div>
                  <span className="text-white font-serif">{track.price}</span>
                </div>
                
                <div className="flex items-center justify-between mt-6 pt-6 border-t border-white/5 text-text-muted text-xs uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <Clock size={14} /> {track.duration}
                  </div>
                  <button className="flex items-center gap-2 hover:text-white transition-colors">
                    <Download size={14} /> Download
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MusicLibrary;
